module.exports = __webpack_public_path__ + "_assets/img/pic.3349c9ba.svg";